module.exports = __webpack_public_path__ + "img/3OOx5O.d41d8cd9.svg";